function exclusive(widget) {
  const eventCallback = eventHandler;

  /**
   * init - Init the widget by creating the eventListener
   *
   * @return {undefined}
   */
  function init() {
    widget.summaries.on('click', eventCallback);
    handleAriaDisabled();
  }

  /**
   * eventHandler - Handle logic
   *
   * @param  {object} event The event object
   * @return {undefined}
   */
  function eventHandler(event) {
    if (event.isTrusted) {
      widget.items.each(function (index) {
        widget.close(index, false);
      });
      window.setTimeout(() => {
        handleAriaDisabled();
      }, 1);
    }
  }

  function handleAriaDisabled () {
    widget.items.each(function () {
      $(this).attr('aria-disabled', this.open);
    });
  }

  /**
   * destroy - Clear event listeners
   *
   * @return {undefined}
   */
  function destroy() {
    widget.summaries.off('click', eventCallback);
  }

  init();

  return {
    destroy
  };
}

exclusive.id = 'exclusive';

export default exclusive;
